export default [
  {
    path: "/analise",
    component: () =>
      import(
        /* webpackChunkName: "index-analise" */
        "../views/Venda/Index.vue"
      ),
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: "",
        component: () =>
          import(
            
            /* webpackChunkName: "lista-analise" */
            "../views/Venda/Lista.vue"
          ),
      },
      {
        path: ":id",
        component: () =>
          import(
            /* webpackChunkName: "analise-venda" */
            "../views/Venda/Visualizar.vue"
          ),
        props: true,
      },
      {
        path: "editar/:id",
        component: () =>
          import(
            /* webpackChunkName: "analise-venda" */
            "../views/Venda/Editar.vue"
          ),
        props: true,
      },
    ],
  },
];
